import HandHolding from '../graphics/hand-holding'
import Section from '../components/section'

type TestimonialProps = {
  quote: string
  author: string
}

export default function Testimonial({ quote, author }: TestimonialProps) {
  return (
    <Section className="flex flex-col items-center">
      <div className="max-w-[1600px] mb-4">
        <span className="block h-28 text-[156px] md:text-9xl md:h-16 text-primaryBlue mb-7 select-none">*****</span>
        <h3 className="mb-7 text-balance">{quote}</h3>
        <p className="text-2xl mb-10 text-balance">{author}</p>
      </div>
      <div className="relative -translate-x-28 w-full md:w-3/4 lg:w-1/2 self-start">
        <HandHolding />
      </div>
    </Section>
  )
}
